import { App } from './app.class';
import { Notification } from './notification.class';
import ClipboardJS from 'clipboard';

export class Page {

    constructor() {

        // Kopierfunktion für quellcode des Formulartemplates
        const $btnCopy = document.querySelector("#formtemplate_sourcecode button.copy");
        if($btnCopy) {
            const templateClipboard = new ClipboardJS($btnCopy, {
                text: function(trigger) {
                    const $code = document.querySelector("#formtemplate_sourcecode pre > code");
                    let text = $code.textContent.trim();
                    return text;
                }
            });
            templateClipboard.on('success', event => {
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                new Notification().success(msg);
            });
        }

    }
}

// Initialisierung wenn DOM geladen
App.domready(()=>{
    if(document.querySelector('body').classList.contains('form-integration')) {
        new Page();
    }
});